<ion-row *ngIf="loading">
    <ion-col size="12" class="ion-text-center">
        <ion-spinner color="primary"></ion-spinner>
    </ion-col>
</ion-row>
<ion-row *ngIf="selectedworkshop && customertzdisplay">
    <ion-col size="12" class="ion-text-center">
        <ion-row>
            <ion-col size="8" class="ion-text-left ion-align-self-center">
                <p class="workshop-title">Your workshop is on <span class="{{selectedworkshop.timeslot.days}}-color">{{selectedworkshop.timeslot.days}}</span> {{selectedworkshop.timeslot.timeslot | lowercase}}s</p>
                <p class="workshop-time">from <b>{{selectedworkshop.timeslot.starttime}}</b> to <b>{{selectedworkshop.timeslot.endtime}}</b> your time ({{this.customertzdisplay}})</p>
            </ion-col>
            <ion-col size="4" class="ion-text-center ion-align-self-center ion-padding-horizontal">
                <img src="/assets/imgs/business/illustration-online-workshop-screen-only.svg" alt="Saturday Workshops">
            </ion-col>
        </ion-row>
    </ion-col>
</ion-row>